import React from 'react';
import TableBoolean from '../../../components/Table/TableBoolean/TableBoolean';
import moment from 'moment';
import _ from 'lodash';

const headerStyle = () => {
    return { borderColor: '#a81933' };
};

const columnStyle = () => {
    return { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' };
};

export const columns = [
    {
        dataField: 'statusId',
        text: 'Status',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle,
        formatter: (_cell, row) => <TableBoolean value={row.statusId === 1} text={row.statusName} />,
    },
    {
        dataField: 'name',
        text: 'Vendor',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    },
    {
        dataField: 'marketplaceCategoryName',
        text: 'Category',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    },
    {
        dataField: 'startAt',
        text: 'Start At',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle,
        formatter: (_cell, row) => {
            if (!_.isEmpty(row.startAt)) { return moment(row.startAt).format('MM/DD/YYYY'); }
        }
    },
    {
        dataField: 'endAt',
        text: 'End At',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle,
        formatter: (_cell, row) => {
            if (!_.isEmpty(row.endAt)) { return moment(row.endAt).format('MM/DD/YYYY'); }
        }
    },
    {
        dataField: 'isLocal',
        text: 'Local?',
        sort: true,
        formatter: (_cell, row) => <TableBoolean value={row.isLocal} />,
        headerStyle: () => { return { width: '130px', ...headerStyle() }; }
    }
];
    
export const sorting = [{
    dataField: 'name',
    order: 'desc'
}];